import { createEnterKeyHandler } from 'utils/form'
import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'
import {
  OTA_PENDING_FILTER_STATUS_OPTIONS,
  OTA_PENDING_SELLER_OPTIONS,
} from 'static/constants_ota_pending'
import { InputText, InputRadio, Button } from 'components/atoms'

export interface IOtaPendingFilterOptions {
  status?: string
  seller?: string
  tour_date?: string
  customer_email?: string
  seller_booking_id?: string
}

interface IProps {
  filterOptions: IOtaPendingFilterOptions
  setFilterOptions: React.Dispatch<React.SetStateAction<IOtaPendingFilterOptions>>
  setShowFilter: React.Dispatch<React.SetStateAction<any>>
}

const OtaPendingReservationFilter: React.VFC<IProps> = ({
  filterOptions,
  setFilterOptions,
  setShowFilter,
}) => {
  const [status, setStatus] = React.useState(filterOptions.status || '')
  const [seller, setSeller] = React.useState(filterOptions.seller || '')
  const [tourDate, setTourDate] = React.useState(filterOptions.tour_date || '')
  const [customerEmail, setCustomerEmail] = React.useState(filterOptions.customer_email || '')
  const [sellerBookingId, setSellerBookingId] = React.useState(
    filterOptions.seller_booking_id || ''
  )

  const handleConfirm = React.useCallback(() => {
    setFilterOptions({
      status,
      seller,
      tour_date: tourDate,
      customer_email: customerEmail,
      seller_booking_id: sellerBookingId,
    })
    setShowFilter(false)
  }, [status, seller, tourDate, customerEmail, sellerBookingId, setFilterOptions, setShowFilter])

  const handleSearchKeyDown = createEnterKeyHandler(handleConfirm)

  return (
    <Wrapper>
      <div className="scroller">
        <div className="filterCategory">
          <div className="type">ステータス</div>
          <div className="options">
            <InputRadio
              name="status"
              onChangeHandler={e => setStatus(e.target.value)}
              options={OTA_PENDING_FILTER_STATUS_OPTIONS}
              defaultValue={status}
            />
          </div>
        </div>

        <div className="filterCategory">
          <div className="type">販売元</div>
          <div className="options">
            <InputRadio
              name="seller"
              onChangeHandler={e => setSeller(e.target.value)}
              options={OTA_PENDING_SELLER_OPTIONS}
              defaultValue={seller}
            />
          </div>
        </div>

        <div className="filterCategory">
          <div className="type">検索</div>
          <div className="textInputs">
            <InputText
              name="customer_email"
              onKeyDownHandler={handleSearchKeyDown}
              value={customerEmail}
              onChangeHandler={e => setCustomerEmail(e.target.value)}
              placeholder="顧客メールアドレス"
            />
            <InputText
              name="seller_booking_id"
              onKeyDownHandler={handleSearchKeyDown}
              value={sellerBookingId}
              onChangeHandler={e => setSellerBookingId(e.target.value)}
              placeholder="OTA予約ID"
            />
          </div>
        </div>

        <div className="filterCategory">
          <div className="type">ツアー日</div>
          <div className="textInputs">
            <InputText
              name="tour_date"
              type="date"
              value={tourDate}
              onChangeHandler={e => setTourDate(e.target.value)}
              placeholder="ツアー日"
            />
          </div>
        </div>
      </div>
      <div className="actions">
        <div className="action">
          <Button handleClick={() => setShowFilter(false)}>キャンセル</Button>
          <Button primary={true} handleClick={handleConfirm}>
            フィルター
          </Button>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  font-size: 12px;
  background-color: ${constants.COLORS.white};
  border: solid 1px ${constants.COLORS.divider};
  border-radius: 4px;
  box-shadow: ${constants.COLORS.cardShadow};
  z-index: 6001;
  .scroller {
    max-height: calc(100dvh - 13rem);
    padding: 16px 16px 80px;
    overflow-y: auto;
  }
  .filterCategory {
    margin-bottom: 20px;
    .type {
      margin-bottom: 8px;
      color: ${constants.COLORS.subText};
      font-weight: bold;
    }
    .textInputs {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .options {
      display: flex;
      flex-wrap: wrap;
      &.gapped {
        gap: 8px 16px;
      }
      .InputRadio_Labels {
        gap: 8px 16px;
        label {
          span {
            font-size: 13px;
            font-weight: normal;
          }
        }
      }
    }
  }
  .actions {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px;
    background-color: ${constants.COLORS.white};
    border-top: solid 1px ${constants.COLORS.divider};
    border-radius: 0 0 4px 4px;
    .action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      button {
        width: calc(50% - 8px);
      }
    }
  }
`

export default OtaPendingReservationFilter
